export default "__VITE_ASSET__BkMk6kFn__"